.list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.children {
    list-style: none;
    /* margin-left (not padding-left) for indent so ::after sits at the
       nested LI's left edge — matches DibApp2020 toc-list TocList OL,
       where the 2px grey nest stripe lives at OL `left: 0` after a
       15px offset from the parent LI. */
    margin: 0 0 0 0.9375rem;
    padding: 0;
    position: relative;
}

/* Nest stripe: 2px light-grey vertical bar at the OL's left edge.
   Mirrors DibApp2020 toc-list `OL::after` — left: 0, top: 3.75px,
   height: calc(100% - 3.75px), background `rgb(208, 214, 220)`. */
.children::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0.234375rem;
    width: 2px;
    height: calc(100% - 0.234375rem);
    background-color: rgb(208, 214, 220);
}

.link {
    display: block;
    /* 3.75px top/bottom, 0 right, 15px left — matches dibdev. */
    padding: 0.234375rem 0 0.234375rem 0.9375rem;
    /* #333 matches dibdev; the styled-component there wraps text in a
       <span> that hard-overrides any link color to rgb(51, 51, 51). */
    color: #333;
    text-decoration: none;
    font-size: 0.9375rem;
    line-height: 1.4;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0.5rem;
}

.link:hover {
    text-decoration: underline;
}

.active {
    font-weight: 400;
    background-color: hsl(195, 20%, 96%);
    /* Stacking context above the ancestor `.children::after` nest stripe,
       which would otherwise paint on top of (and hide) the active
       stripe — both stripes share the same x position when the active
       item is nested. */
    z-index: 1;
}

/* Active-item stripe: 2px navy bar at the LI's left edge.
   Mirrors DibApp2020 toc-item.tsx TreeNode `&::after` —
   theme-color-primary-4 (`hsl(197, 97%, 12%)`, dark navy). */
.active::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 2px;
    height: 100%;
    background-color: hsl(197, 97%, 12%);
}
